/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'
export const getKeycloakAllUsers = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/keycloak/getAllUsers?realm=` + param.realm).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const createKeyCloadUser = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/keycloak/createUser?realm=` + param.realm + '&password=' + param.password + '&username=' + param.username + '&firstName=' + param.firstName + '&lastName=' + param.lastName + '&email=' + param.email, param).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
export const createMySQLConnectionKeycloak = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/keycloak/createMySQLConnection?realm=` + param.realm + '&userName=' + param.userName + '&connectionName=' + param.connectionName + '&connectionUser=' + param.connectionUser + '&connectionPass=' + param.connectionPass, param).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
export const deleteKeyCloakUser = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/keycloak/deleteUser?realm=` + param.realm + '&username=' + param.username).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
export const getKeycloakUsersCount = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/keycloak/getUserCount?realm=` + param.realm).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
